export default "__VITE_ASSET__CmpMkMkT__"